import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "credivive",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  interest_rate: 30,
  comision: 3,
  iva: 16,
  companyNames: ["Credi Vive Peninsular SAPI de CV SOFOM ENR", "Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_5m8phYNNU",
      userPoolClientId: "55p45ui49f0so2h5miipao90ne",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_V2zUklsEW",
      userPoolClientId: "aebr0m7bo1dhofo8gug43atdj",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
